import React, { useState, useEffect, useContext } from "react";
import { motion } from "framer-motion";

import pizzaIco from "../assets/img/pizza.svg";
import pizzasData from "../data-api.json";
import displaySpicy from './utils/spicy'

import Context from "./Context/Context"

const variantsList = {
    initial: {
        y: "-100vh"
    },
    show: {
      y: 0,
      transition: {
        delay: 0,
        type: "spring",
        stiffness: 65,
      }
    },
    hide: {
      y: "-100vh",
      transition: {
        delay: 0,
        type: "spring",
        stiffness: 65,
      }
    }
}

const variantsParent = {
    initial:{ opacity: 0,},
    show:{ opacity: 1 },
    hide:{ opacity: 0 }
}

const Popup = ({ displayPopupPizza, id }) => {
  const [close, setClose] = useState(false);
  const [pizza, setPizza] = useState(null);
  const [disabledBtn, setDisabledBtn] = useState(false)
  const { addToBasket } = useContext(Context)

  useEffect(() => {
    setPizza(s => {
      return {...s, ...pizzasData[id]}
    })
  }, [id])

  const handleClose = (e) => {
    e.preventDefault();
    if(disabledBtn === true) return;
    if(e.target.classList.contains('main__popup')
    || e.target.classList.contains('btn-info')) {
      setDisabledBtn(true);
      setClose(close => !close);
      setTimeout(() => {
        displayPopupPizza(null);
      }, 600);
    }
  }

  useEffect(() => {
    return () => {
      setDisabledBtn(false);
    }
  }, [])

  return (
    <motion.div
    variants={variantsParent}
    initial="initial"
    animate={!close ? "show" : "hide"}
    onClick={(e) => handleClose(e)}
    className="main__popup">
      <motion.div 
        variants={variantsList}
        animate={close ? "hide" : "show"}
        initial="initial"
        className="main__popup__bg">
            <div
                className="main__popup__content">
                <img src={pizzaIco} alt="pizza" />

                {
                  pizza && 
                  (
                    <div className="main__popup__desc">
                      <h1>{pizza.title}</h1>
                      <div className="main__popup__desc__head">
                        <h3>Catégorie : { pizza.category }</h3>
                        <h3 className="spicy">
                          { pizza.spicy !== 0 ? <span>Spicy :</span> : "" }
                          { displaySpicy( pizza.spicy ) }
                        </h3>
                        <h3>Price : ${ pizza.price }</h3>
                      </div>
                      <p>
                        {pizza.desc}
                      </p>
                      <div className="btns">
                      <button 
                      className="btn btn-info">Close</button>
                      <button 
                      onClick={() => addToBasket(pizza)}
                      className="btn btn-primary">Add to card</button>
                      </div>
                    </div>
                  )
                }
                
            </div>
      </motion.div>
    </motion.div>
  );
};

export default Popup;
